import { defineStore } from 'pinia';
import {getColors} from '../api.js';

export const useColorStore = defineStore('colors', {
    state: () => ({
        colors: [],
        loading: false,
        error: null
    }),
    actions: {
        async fetchColors() {
            this.loading = true;
            this.error = null;
            try {
                const data = await getColors();
                this.colors = data.data;
            } catch (err) {
                this.error = err;
            } finally {
                this.loading = false;
            }
        }
    },
});
